module.exports = __webpack_public_path__ + "static/media/ManuelCorreaZavala.2f34177d.jpg";